import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getQueryParamsState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.queryPrams
);

export const getQueryParams = createSelector(
  getQueryParamsState,
  ({ queryParams }) => queryParams
);

export const getHasDeepLinkingParams = createSelector(
  getQueryParamsState,
  ({ hasDeepLinkingParams }) => hasDeepLinkingParams
);
